import { Tooltip, Typography } from '@mui/material'
import type { TypographyProps } from '@mui/material/Typography'
import React, { useState } from 'react'
import type { TextTruncateProps } from 'react-text-truncate'
import TextTruncate from 'react-text-truncate'

type TruncatedTextProps = { line: TextTruncateProps['line']; text: string | undefined } & Omit<
  TypographyProps,
  'children'
>

const TruncatedText: React.FC<TruncatedTextProps> = ({ text, line, ...typographyProps }) => {
  const [isTruncated, setIsTruncated] = useState(false)

  return (
    <Tooltip title={isTruncated ? text : undefined}>
      <Typography {...typographyProps}>
        <TextTruncate text={text} line={line} onTruncated={() => setIsTruncated(true)} />
      </Typography>
    </Tooltip>
  )
}

export default TruncatedText
